import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import isEmpty from 'lodash/isEmpty';

// Components
import TTTable from "./TTTable";
import Loader from "../../../../utils/Loader";

class TTSearch extends Component{
    constructor(props){
        super(props);

		this.state = {
            loading: false,
            currentPage: 1,
            leftIndex: 0,
            rightIndex: 0,
            q: '',
            dataSearched: []
		};
    }

    componentDidMount(){
        //Right index initialization
        this.setState({
            rightIndex: this.props.itemsPerPage,
            loading: false
        }, () => {
            if(!isEmpty(this.props.searchQuery)){
                this.setState({
                    q: this.props.searchQuery
                }, () => this.handleSearch(this.props.searchQuery))
            }
        });
    }

    prevPage = () => {
        const rightIndex = this.state.leftIndex;
        const leftIndex = this.returnMinLeftIndex(this.state.leftIndex - this.props.itemsPerPage)

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage === 1 ? 1 : this.state.currentPage - 1
        })
    }

    nextPage = () => {
        const leftIndex = this.state.rightIndex;
        const rightIndex = this.returnMaxRightIndex(leftIndex + this.props.itemsPerPage);

        this.setState({
            leftIndex: leftIndex,
            rightIndex: rightIndex,
            currentPage: this.state.currentPage + 1
        })
    }

    // Gets the highest right index (based on the max length of array)
    returnMaxRightIndex = (testIndex) => {
        return testIndex > this.props.data.length ? this.props.data.length : testIndex;
    }

    // Gets the lowest index, forcing 0 to be the minimum
    returnMinLeftIndex = (testIndex) => {
        return testIndex < 0 ? 0 : testIndex;
    }

    handleSearch(value, type){
        this.props.storeSearch(value);

        this.setState({
            isSearching: true,
            q: value,
            currentPage: 1,
            leftIndex: 0,
            rightIndex: this.returnMaxRightIndex(0 + this.props.itemsPerPage)
        }, () => {
            if(isEmpty(value)){
                this.setState({
                    isSearching: false
                });
            } else {
                if(type === 'customers'){
                    this.setState({ 
                        dataSearched: this.props.data.filter(item => item.fname.toLowerCase().includes(value.toLowerCase()) || item.lname.toLowerCase().includes(value.toLowerCase()) || item.email.toLowerCase().includes(value.toLowerCase()) )
                    })
                } else {
                    this.setState({ 
                        dataSearched: this.props.data.filter(item => item.title.toLowerCase().includes(value.toLowerCase()) || item.sku.toLowerCase().includes(value.toLowerCase()) )
                    })
                }
            }
        })
    }
    
    render(){
        const { type, data, notification } = this.props;
        const { loading, currentPage, leftIndex, rightIndex, q, isSearching, dataSearched } = this.state;
        let tableData = isSearching ? dataSearched : data;
        const lastPage = Math.floor((tableData.length - 1) / 10 + 1);

        return (
            <Fragment>
                {loading ? 
                <div className="pt2 pb2">
                    <Loader />
                </div> :
                <Fragment>
                    {/* Searchbar */}
                    <div className="ajax-search-wrapper tt-searchbar">
                        <div className={`input-placeholder-wrapper placeholder--search-field`}>
                            <span className="placeholder icon-search" />
                            <input type="text" value={q} placeholder={type === 'customers' ? "Search customers" : "Search products"} onChange={e => this.handleSearch(e.target.value, type)}/>
                        </div>
                    </div>

                    {/* Pagination */}
                    <div className="customer-search-items-pagination assigned-products">
                        <button disabled={currentPage === 1} onClick={() => this.prevPage()}> 
                            <div className="icon-backward"></div>
                            Prev
                        </button>
                        <div className="customer-search-items-pagination-page">{currentPage + ' - ' + (lastPage === 0 ? '1' : lastPage)}</div>
                        <button disabled={rightIndex >= tableData.length} onClick={() => this.nextPage()}>
                            Next
                            <div className="icon-forward"></div>
                        </button>
                    </div>

                    {/* Data Table */}
                    <TTTable 
                        q={q}
                        data={tableData} 
                        type={type} 
                        buttonText={type === 'add' ? 'Add' : 'Remove'}
                        notification={notification}
                        leftIndex={leftIndex}
                        rightIndex={rightIndex}
                        action={(type, prod_id) => this.props.action(type, prod_id)}
                    />
                </Fragment>
                }
            </Fragment>
        )
    }
    
}

const mapStateToProps = (state) => {
    return {
        user: state.user.admin
    }
}

export default connect(mapStateToProps, {})(TTSearch);


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/products/products-search/TTSearch.js